import { createSlice } from "@reduxjs/toolkit";

export const opportunitySlice = createSlice({
  name: "opportunity",
  initialState: {
    dataToAction: {
      dateOpportunity: "",
      reservationDeadline: "",
      amount: "",
      investmentType: "",
      roundNumber: "",
      urlVideo: "",
      startup: "",
      status: "",
      isInApp: false,
    },
  },
  reducers: {
    selectOpportunity: (state, { payload }) => {
      state.dataToAction = payload;
    },
    unSelectOpportunity: (state) => {
      state.dataToAction = {
        dateOpportunity: "",
        reservationDeadline: "",
        amount: "",
        investmentType: state.dataToAction.investmentType,
        roundNumber: "",
        urlVideo: "",
        startup: "",
        status: "",
        isInApp: false,
      };
    },
  },
});

export const { selectOpportunity, unSelectOpportunity } =
  opportunitySlice.actions;
